<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Article item editor
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="min-height: 300px; padding-top: 20px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        Error. <br>{{errMsg}}
      </div>

      <div *ngIf="['error','loading'].indexOf(state) === -1">
        <mat-form-field appearance="outline" color="accent"
                        style="width: 100%;">
          <mat-label>Item type</mat-label>
          <mat-select [formControl]="typeValue" disabled="{{mode === 'edit'}}" (selectionChange)="typeChanged()">
            <mat-option value="title">Title/Header</mat-option>
            <mat-option value="text">Text paragraph</mat-option>
            <mat-option value="image">Image or Youtube video</mat-option>
            <mat-option value="cta">Link or Ad block</mat-option>
          </mat-select>
        </mat-form-field>

        <app-quick-uploader [class.hidden]="['image','cta'].indexOf(itemType)===-1"
                            [picture_src]="picture_src" [aspect_ratio]="aspect_ratio"
                            (new_picture_src)="picture_src = $event"
                            (new_aspect_ratio)="aspect_ratio = $event"
        >
        </app-quick-uploader>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['title'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Title</mat-label>
          <mat-icon matPrefix>title</mat-icon>
          <input matInput [formControl]="titleValue" type="text">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['titleValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['titleValue']}}</span>
        </div>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['text','cta'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Text paragraph</mat-label>
          <textarea matInput [formControl]="textValue"
                    value=""
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="{{cdkAutosizeMinRows}}"
                    cdkAutosizeMaxRows="{{cdkAutosizeMaxRows}}"></textarea>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['textValue']">
          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.messagesPerControls['textValue']}}</span>
        </div>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['image','cta'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Caption</mat-label>
          <mat-icon matPrefix>title</mat-icon>
          <input matInput [formControl]="captionValue" type="text">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['captionValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['captionValue']}}</span>
        </div>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['image'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Youtube video URL</mat-label>
          <mat-icon matPrefix>play_circle_outline</mat-icon>
          <input matInput [formControl]="videoValue" type="text" (keyup)="fetchYoutubePicture()">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['videoValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['videoValue']}}</span>
        </div>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['cta'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Web link</mat-label>
          <mat-icon matPrefix>link</mat-icon>
          <input matInput [formControl]="linkValue" type="text">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['linkValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['linkValue']}}</span>
        </div>

        <mat-form-field appearance="outline" color="accent"
                        [class.hidden]="['cta'].indexOf(itemType)===-1" style="width: 100%">
          <mat-label>Web link text</mat-label>
          <mat-icon matPrefix>short_text</mat-icon>
          <input matInput [formControl]="linkTextValue" type="text">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['linkTextValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['linkTextValue']}}</span>
        </div>
      </div>

    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Save
      </button>
    </div>
  </div>
</form>
